import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/AuthContext';

export default function LogoutHandler() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();        // clear auth
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  return null; // or a spinner if you want
}
